export function decodeBase64VC(encoded: string): object {
    try {
        if (!encoded || encoded === 'Error!') return {};
        return JSON.parse(atob(encoded));
    } catch {
        return {};
    }
}
